module.exports = __webpack_public_path__ + "static/media/pvt.5928fa1d.png";